export default "__VITE_ASSET__DhHcwPPi__"